export const serviceById = {
  1: 'INSTALAÇÃO',
  2: 'MANUTENÇÃO',
  3: '',
  4: 'RETIRADA',
  5: 'TESTE BANCADA',
  6: 'REINSTALAÇÃO'
}
